import { render, staticRenderFns } from "./vehRegChassisChgAppendixD.vue?vue&type=template&id=ca40b0c8&"
import script from "./vehRegChassisChgAppendixD.vue?vue&type=script&lang=js&"
export * from "./vehRegChassisChgAppendixD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports